import { ResponsiveHeatMap } from '@nivo/heatmap';

// Generate fake data for heatmap
const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const hours = ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'];
const heatmapData = days.map(day => ({
  id: day,
  data: hours.map(hour => ({ x: hour, y: Math.floor(Math.random() * 200) })),
}));

export const ActivityHeatmapChart = () => (
    <div style={{ height: '400px' }}>
        <ResponsiveHeatMap
            axisLeft={{ tickSize: 5, tickPadding: 5, tickRotation: 0, legend: 'Day of Week', legendPosition: 'middle', legendOffset: -72 }}
            axisTop={{ tickSize: 5, tickPadding: 5, tickRotation: -45, legend: 'Time of Day', legendOffset: -50 }}
            colors={{ type: 'diverging', scheme: 'cool', minValue: 0, maxValue: 200, }}
            data={heatmapData}
            emptyColor="#555555"
            legends={[{
                anchor: 'bottom',
                translateX: 0,
                translateY: 40,
                length: 400,
                thickness: 8,
                direction: 'row',
                tickPosition: 'after',
                tickSize: 3,
                tickSpacing: 4,
                tickOverlap: false,
                tickFormat: '>-.2s',
                title: 'User Activity →',
                titleAlign: 'start',
                titleOffset: 4,
            }]}
            margin={{ top: 60, right: 90, bottom: 60, left: 90 }}
            valueFormat=">-.2s"
        />
    </div>
);